import { api_GET, api_POST, api_PUT } from './_api';

const documento_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListDocumentosCategoria: (categoria) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetListDocumentosCategoria/${categoria}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Documento/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Documento/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`Documento/`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default documento_api;